import React, { ReactNode, useEffect } from 'react';
import { Overlay } from '@mantine/core';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useLocalStorage } from '@mantine/hooks';

import leftImg from '../../assets/working-illustration.png';
import { useAuth } from '../../context/AuthProvider';
import { useAuthStore } from '../../stores/auth.store';
import { MODULE_DATA } from '../../constants/navigation';

interface Props {
    children: ReactNode;
}

export default function AuthLayout({ children }: Props) {
    const { isLoggedIn } = useAuthStore();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { redirectUrl, loadingAuthUser, setRedirectUrl } = useAuth();
    const [searchParams] = useSearchParams();

    const [selectedModule] = useLocalStorage({
        key: 'selectedModule',
        defaultValue: undefined,
    });
    const selectedModuleString =
        typeof selectedModule === 'string' ? selectedModule : null;
    const selectedModuleData = MODULE_DATA[selectedModuleString ?? ''];

    useEffect(() => {
        if (searchParams.has('redirectUrl')) {
            setRedirectUrl(searchParams.get('redirectUrl') ?? '');
        }
    }, [searchParams, isLoggedIn]);

    useEffect(() => {
        if (!loadingAuthUser && isLoggedIn && pathname.includes('auth')) {
            if (redirectUrl) {
                navigate(redirectUrl);
            } else if (selectedModuleData) {
                navigate(selectedModuleData.link, { replace: true });
            } else {
                navigate(redirectUrl || '/dashboard', { replace: true });
            }
        }
    }, [loadingAuthUser, isLoggedIn]);

    return (
        <div className="flex w-full max-w-screen h-screen">
            <div className="lg:block xl:block lg:w-1/2 xl:w-9/12 overflow-hidden relative hidden">
                <img
                    src={leftImg}
                    className="h-full lg:w-full lg:object-cover object-center"
                    alt="working-illustration"
                />
                <Overlay
                    gradient="linear-gradient(180deg, #1E5FA6 0%, #000000 114.44%)"
                    className="opacity-50 z-0"
                />
            </div>
            <div className="flex h-full w-full items-center justify-center">
                <div className="flex justify-center max-w-[440px] h-full lg:h-auto xl:h-auto  w-full p-8">
                    {children}
                </div>
            </div>
        </div>
    );
}
